"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ProductGroup_1 = require("../components/product-group/ProductGroup");
const useProductTileHelpers_1 = require("../hooks/useProductTileHelpers");
const ActionEnums_1 = require("../enums/ActionEnums");
const andes_react_1 = require("@yonderland/andes-react");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../constants/i18nConstants");
const common_components_1 = require("@as-react/common-components");
const AuthorLinkedProductsContainer = ({ productGroupId, products, name, }) => {
    const { handleWishlistToggle, handleUpdateCompareList, handleAddToBasket, compareItems } = (0, useProductTileHelpers_1.useProductTileHelpers)();
    const { feature_toggles: { lowest_price_all }, } = (0, common_components_1.useAemConfig)();
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.general);
    if (!products || products.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(andes_react_1.Box, { paddingBlock: { base: '10', md: '12', xl: '16' }, children: [name && ((0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { color: 'emphasised', variant: 'headingS', as: "h2", children: t('author.page.products.title', {
                    name: name,
                }) })), (0, jsx_runtime_1.jsx)(ProductGroup_1.ProductGroup, { removeOuterSpacing: true, addToBasket: (...args) => handleAddToBasket(...args, ActionEnums_1.ProductAddToBasketLocations.PRODUCT_GROUP), collapsible: false, compareItems: compareItems, onWishListToggle: handleWishlistToggle, products: products, productGroupId: `product-group-${productGroupId}`, updateCompareList: handleUpdateCompareList, enablePriceReference: lowest_price_all })] }));
};
exports.default = AuthorLinkedProductsContainer;
